import { Org } from '@/types';
import { Button } from '@nautilusbio/nb-design-system/Button';
import { useNavigate } from '@tanstack/react-router';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useSwitchOrganization from '../hooks/useSwitchOrganization';

const StudiesCellRenderer = ({ data }: { data: Org }) => {
  const { t } = useTranslation('orgs');
  const { handleChange, isSelected } = useSwitchOrganization(data);
  const navigate = useNavigate();

  const handlePress = useCallback(
    () => (!isSelected ? handleChange(true) : navigate({ to: '/studies' })),
    [handleChange, isSelected, navigate],
  );

  return (
    <Button
      aria-label={t('view_studies', { count: data.num_studies, name: data.name })}
      data-testid={`studies-cell-${data.id}`}
      isDisabled={data.num_studies === 0}
      onPress={handlePress}
      visual="unstyled"
    >
      {String(data.num_studies)}
    </Button>
  );
};

export default memo(StudiesCellRenderer);
